import { makeGet, makePatch } from '../../utils/call-api-endpoint';
import type { Envelope } from '../../utils/envelope';
import type { GanadoEnCorral } from './ganado';

export async function obtenerGanadoEnCorral(idCorral: number): Promise<Envelope<GanadoEnCorral[]>> {
  const response = await makeGet<GanadoEnCorral[]>(`/ganado/en-corral/${idCorral}`);

  return response;
}

export async function obtenerCantidadGanadoEnCorral(idCorral: number): Promise<Envelope<number>> {
  const response = await makeGet<number>(`/ganado/cantidad-en-corral/${idCorral}`);

  return response;
}

export async function obtenerGanadoPorArete(tipoArete: TipoArete, arete: string): Promise<Envelope<GanadoEnCorral>> {
  const response = await makeGet<GanadoEnCorral>(`/ganado/por-arete/${tipoArete}/${arete}`);

  return response;
}

export type TipoArete = 'siiniga' | 'temporal';

export interface PonerDatosPreñadaRequest {
  idCorral: number;
  partida: number;
  folioInterno: string;
  fechaTacto: Date;
  fechaParto: Date;
  mesesGestacion: number;
  notas: string;
}

export async function ponerDatosPreñada(
  request: PonerDatosPreñadaRequest
): Promise<Envelope<string>> {
  const response = await makePatch<PonerDatosPreñadaRequest, string>(
    `/ganado/poner-cargada`,
    request
  );

  return response;
}

export interface PonerDatosParidaRequest {
  idCorral: number;
  partida: number;
  folioInterno: string;
  paridaTipo: number;
  notas: string;
}

export async function ponerDatosParida(
  request: PonerDatosParidaRequest
): Promise<Envelope<string>> {
  const response = await makePatch<PonerDatosParidaRequest, string>(
    `/ganado/poner-parida`,
    request
  );

  return response;
}

export interface PonerDatosBajaRequest {
  idCorral: number;
  partida: number;
  folioInterno: string;
  fechaBaja: Date;
  motivo: number;
  notas: string;
}

export async function ponerDatosBaja(request: PonerDatosBajaRequest): Promise<Envelope<string>> {
  const response = await makePatch<PonerDatosBajaRequest, string>(`/ganado/poner-baja`, request);

  return response;
}

export interface CambiarZonaRequest {
  partida: number;
  folioInterno: string;
  idZona: number;
}

export async function cambiarZona(request: CambiarZonaRequest): Promise<Envelope<string>> {
  const response = await makePatch<CambiarZonaRequest, string>(`/ganado/cambiar-zona`, request);

  return response;
}

export interface QuitarDatosBajaRequest {
  partida: number;
  folioInterno: string;
  idCorral: number;
}

export async function quitarDatosBaja(request: QuitarDatosBajaRequest): Promise<Envelope<string>> {
  const response = await makePatch<QuitarDatosBajaRequest, string>(`/ganado/quitar-baja`, request);

  return response;
}

export interface QuitarDatosPreñadaRequest {
  partida: number;
  folioInterno: string;
  idCorral: number;
}

export async function quitarDatosPreñada(request: QuitarDatosPreñadaRequest): Promise<Envelope<string>> {
  const response = await makePatch<QuitarDatosPreñadaRequest, string>(`/ganado/quitar-cargada`, request);

  return response;
}

export interface QuitarDatosParidaRequest {
  partida: number;
  folioInterno: string;
  idCorral: number;
}

export async function quitarDatosParida(request: QuitarDatosParidaRequest): Promise<Envelope<string>> {
  const response = await makePatch<QuitarDatosParidaRequest, string>(`/ganado/quitar-parida`, request);

  return response;
}
